export default "__VITE_ASSET__Bl0dq3QA__"